<template v-if="family">
  <product-model-selector
    v-if="family?.models?.length"
    :key="family.familyCode"
    v-model="localModelValue"
    :subfamily-models="family.models"
  />
  <sub-family-filter-selector
    v-else
    :key="selectedSubFamily?.familyCode"
    v-model="selectedSubFamily"
    :family="family"
  />
  <sub-family-and-model-selector-container
    v-if="selectedSubFamily"
    :key="selectedSubFamily?.familyCode"
    v-model="localModelValue"
    :family="selectedSubFamily"
  />
</template>

<script setup>
import {ref, watch, computed, defineAsyncComponent} from 'vue';
const ProductModelSelector = defineAsyncComponent(() =>
  import('@/components/containers/buy-zone/ProductModelSelector.vue')
);
const SubFamilyFilterSelector = defineAsyncComponent(() =>
  import('@/components/containers/buy-zone/SubFamilyFilterSelector.vue')
);
const props = defineProps({
  family: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: String,
    default: null,
  },
});

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
});

const emits = defineEmits(['update:modelValue']);

const selectedSubFamily = ref(props.family?.subfamilies?.[0] || null);

function containsModelCode(family, targetCode) {
  if (family.models && family.models.includes(targetCode)) {
    return true;
  }
  if (family.subfamilies && family.subfamilies.length > 0) {
    for (const subfamily of family.subfamilies) {
      if (containsModelCode(subfamily, targetCode)) {
        return true;
      }
    }
  }
  return false;
}

const getSubFamilyForProductCode = function (subfamilies, productCode) {
  return subfamilies?.find((sf) => containsModelCode(sf, productCode)) || props.family?.subfamilies?.[0] || null;
};

watch(
  () => props.modelValue,
  (selectedModelId) => {
    selectedSubFamily.value = getSubFamilyForProductCode(props.family.subfamilies, selectedModelId);
  },
  {immediate: true}
);
</script>
